<h1 mat-dialog-title>Token criado</h1>
<div mat-dialog-content>
    <p>Atenção!</p>
    <p>O token não será exibido novamente. Copie ou salve em um lugar seguro.</p>
    <mat-form-field appearance="outline" style="width: 100%">
        <input matInput readonly [value]="data.token" />
    </mat-form-field>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="copiar()">Copiar</button>
    <button mat-raised-button color="primary" (click)="fechar()">Fechar</button>
</div>